<div style="display: flex">
  <div class="lines" id="line1"></div>
  <div class="lines" id="line2"></div>
  <div class="lines" id="line3"></div>
  <div class="lines" id="line4"></div>
  <div class="lines" id="line5"></div>
  <div class="lines" id="line6"></div>
  <div class="lines" id="line7"></div>
  <div class="lines" id="line8"></div>
  <div class="lines" id="line9"></div>
</div>
<div class="background-image"></div>
<div class="py-0 content">
  <div class="navigation">
    <app-navigation></app-navigation>
  </div>
  <div class="outlet">
    <router-outlet></router-outlet>
  </div>
</div>
